import useAutocomplete from '@mui/material/useAutocomplete';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { autocompleteClasses } from '@mui/material/Autocomplete';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/useAutocomplete": useAutocomplete, "@mui/icons-material/Check": CheckIcon, "@mui/icons-material/Close": CloseIcon, "@mui/material/styles": { styled }, "@mui/material/Autocomplete": { autocompleteClasses } } } });
export default ClientProvider;
